export default "__VITE_ASSET__B86iBTIT__"